<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">add_circle</v-icon>
            Add Keywords
          </span>
        </v-card-title>
        <v-card-text>
          <v-form ref="add_keywords" data-vv-scope="add_keywords" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea
                  v-model="keywords"
                  label="Keywords*"
                  hint="Enter keywords one per line or separated by commas"
                  v-validate="'required'"
                  data-vv-name="add_keywords.keywords"
                  :error-messages="errors.collect('add_keywords.keywords')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveKeywords()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'AddKeywordsModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['addKeywordsDialog', 'projectId', 'loading'],
  data () {
    return {
      dialog: this.addKeywordsDialog,
      keywords: '',
      dictionary: {
        en: {
          custom: {
            'add_keywords.keywords': {
              required: 'Please add keywords'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    addKeywordsDialog: {
      handler () {
        this.dialog = this.addKeywordsDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('addKeywordsDialog', this.dialog)
      }
    }
  },
  methods: {
    saveKeywords () {
      this.$validator.validateAll('add_keywords').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)

          let params = {
            projectId: this.projectId,
            keywords: this.keywordsToArray(this.keywords)
          }

          this.$store.dispatch('ADD_KEYWORDS', params).then(res => {
            this.$toasted.show('Keywords were succsessfully added to project')
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateProject')
            this.$parent.$emit('updateKeywords')
            this.closeModal()
          }, err => {
            console.log('login error', err)
            this.$parent.$emit('loading', false)
            this.$toasted.show('ADD_KEYWORDS ERROR: ' + this.$services.getApiError(err), { type: 'error' })
          })
        }
      })
    },
    keywordsToArray (strKeywords) {
      let arrKeywords = []

      // check if there are some lines
      var match = /\r|\n/.exec(strKeywords)

      if (match) {
        let arrLines = strKeywords.match(/[^\r\n]+/g)
        arrKeywords = arrLines.map((line) => {
          return line.split(',').map((keyword) => { return keyword.trim() })
        })
        // join arrays in array
        arrKeywords = [].concat.apply([], arrKeywords)
      } else {
        arrKeywords = strKeywords.split(',').map((keyword) => { return keyword.trim() })
      }

      // remove empty values
      arrKeywords = arrKeywords.filter((keyword) => {
        return keyword != null && keyword !== ''
      })

      // convert to format with period
      arrKeywords = arrKeywords.map((keyword) => { return [keyword, 1] })

      return arrKeywords
    },
    closeModal () {
      this.dialog = false
      setTimeout(() => {
        this.$validator.errors.clear('add_keywords')
      }, 500)
    },
    formToProject () {
      this.project.id = this.projectData.id
      this.project.name = this.form.name
      this.project.domain = this.form.domain
      this.project.subdomains = this.form.subdomains.split(',').map((subdomain) => { return subdomain.trim() }).filter(subdomain => subdomain)
    },
    clearForm () {
      this.form = {
        name: '',
        domain: '',
        verify: true,
        subdomains: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/add-keywords-modal/AddKeywordsModal.vue